export type GetPredecessorsResponse = {
    results: [{documentID: string}]
}

export const processGetPredecessorsResponse = (res: GetPredecessorsResponse): string[] => {
    return (res?.results ?? []).map(x => x.documentID)
}